(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.EventsController = (function(superClass) {
    extend(EventsController, superClass);

    function EventsController(scope, transitions, modal, http, service, state, q, ngModal) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.state = state;
      this.q = q;
      this.ngModal = ngModal;
      this.formsByField = bind(this.formsByField, this);
      this.eventsByField = bind(this.eventsByField, this);
      this.editForm = bind(this.editForm, this);
      this.addForm = bind(this.addForm, this);
      EventsController.__super__.constructor.apply(this, arguments);
    }

    EventsController.prototype.addForm = function(formType, fieldSurvey) {
      this.service.triggerBrowserWarning = false;
      if (formType === 'fertilizer') {
        return this.ngModal.openFertilizerForm(fieldSurvey.fields_id, this.service.year, null).modalRef.result.then((function(_this) {
          return function() {
            return _this.state.reload('grower.nsolver');
          };
        })(this))["catch"](_.noop);
      } else {
        return this.state.go("grower.add-" + formType, {
          tab: 'plan',
          year: this.service.year,
          field_id: fieldSurvey.fields_id,
          crop: this.service.crop,
          is_ingredion_field: false,
          redirectId: this.state.params.id,
          redirectState: 'nsolver',
          step: this.state.params.step
        });
      }
    };

    EventsController.prototype.editForm = function(formType, fieldSurvey, forms) {
      var afterForm;
      if (forms == null) {
        forms = null;
      }
      this.service.triggerBrowserWarning = false;
      if (forms == null) {
        forms = this.formsByField(formType, fieldSurvey);
      }
      if (formType === 'fertilizer') {
        afterForm = (function(_this) {
          return function() {
            if (forms.length > 0) {
              return _this.editForm(formType, fieldSurvey, forms);
            } else {
              return _this.state.reload('grower.nsolver');
            }
          };
        })(this);
        return this.ngModal.openFertilizerForm(fieldSurvey.fields_id, this.service.year, {
          layers_id: forms.pop()
        }).modalRef.result.then(afterForm)["catch"](afterForm);
      } else {
        return this.state.go("grower.view-" + formType, {
          id: forms[0],
          field: 0,
          year: 0,
          additionalIds: forms.slice(1),
          edit: true,
          is_ingredion_field: false,
          redirectId: this.state.params.id,
          redirectState: 'nsolver',
          step: this.state.params.step
        });
      }
    };

    EventsController.prototype.eventsByField = function(formType, fieldSurvey) {
      return fieldSurvey.events[formType];
    };

    EventsController.prototype.formsByField = function(formType, fieldSurvey) {
      return _.uniq(this.eventsByField(formType, fieldSurvey));
    };

    return EventsController;

  })(Controller);

}).call(this);
